import { Link } from "react-router-dom";
import {
  Hand,
  HardHat,
  Footprints,
  Ear,
  Eye,
  Wind,
  Mountain,
  Flame,
  Shirt,
  ShowerHead,
  TrafficCone,
  SprayCan,
} from "lucide-react";
import { CATEGORIES } from "../lib/constants";
import { MaskedLines, Reveal } from "./motion";

const ICONS = {
  Hand,
  HardHat,
  Footprints,
  Ear,
  Eye,
  Wind,
  Mountain,
  Flame,
  Shirt,
  ShowerHead,
  TrafficCone,
  SprayCan,
};

const CLIP = "polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 0 100%)";

const onSpotlight = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};

export default function Catalog() {
  return (
    <section
      id="catalogo"
      data-testid="catalog-section"
      className="relative bg-background py-24 lg:py-32"
    >
      <div className="pointer-events-none absolute inset-0 bg-blueprint opacity-40" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mb-16 grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <Reveal>
              <div className="overline mb-4 text-pv-orange">
                Capítulo 03 — Catálogo
              </div>
            </Reveal>
            <MaskedLines
              className="font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-pv-green sm:text-5xl lg:text-6xl"
              lines={[
                <>Protección integral,</>,
                <span className="text-pv-lime">de la cabeza a los pies.</span>,
              ]}
            />
          </div>
          <div className="lg:col-span-4">
            <Reveal delay={0.15}>
              <p className="leading-relaxed text-slate-600">
                Más de <strong>500 productos</strong> certificados organizados
                en 12 categorías. Solicite el catálogo completo o cotice
                productos específicos.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6 xl:grid-cols-4">
          {CATEGORIES.map((cat, i) => {
            const Icon = ICONS[cat.icon] || Hand;
            return (
              <Reveal key={cat.id} delay={(i % 4) * 0.06}>
                <Link
                  to={`/catalogo/${cat.id}`}
                  onMouseMove={onSpotlight}
                  data-testid={`catalog-card-${cat.id}`}
                  className="spotlight-card group flex h-full flex-col rounded-sm border border-slate-200 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:border-pv-lime lg:p-7"
                >
                  <div className="mb-8 flex items-start justify-between">
                    <div
                      style={{ clipPath: CLIP }}
                      className="flex h-24 w-24 items-center justify-center border border-pv-green/10 bg-pv-green/5 transition-colors duration-300 group-hover:border-pv-green group-hover:bg-pv-green"
                    >
                      <Icon
                        size={44}
                        className="text-pv-green transition-colors duration-300 group-hover:text-pv-lime"
                      />
                    </div>
                    <span className="overline text-slate-400">{cat.code}</span>
                  </div>
                  <h3 className="mb-2 font-display text-xl font-bold tracking-tight text-pv-green">
                    {cat.name}
                  </h3>
                  <p className="flex-1 text-sm leading-relaxed text-slate-600">
                    {cat.desc}
                  </p>
                  <div className="mt-6 flex items-center gap-1 border-t border-slate-100 pt-4 text-xs font-semibold text-pv-orange transition-all group-hover:gap-2">
                    Ver productos
                    <span>→</span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>

        <Reveal className="mt-12 text-center">
          <a
            href="https://customer-assets.emergentagent.com/job_3a65f364-f8cc-476a-886c-ed59a87eeab6/artifacts/kke1hnrw_Catalogo%20pvi%202026.pdf"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="download-catalog"
            className="inline-flex items-center gap-2 border-b-2 border-pv-green pb-1 font-semibold text-pv-green transition-colors hover:border-pv-orange hover:text-pv-orange"
          >
            Descargar Catálogo
          </a>
        </Reveal>
      </div>
    </section>
  );
}
